module.exports = __webpack_public_path__ + "assets/img/logo_footer_white.3b5b8c85.svg";